// Core
import React from "react";
import ReactDOM from "react-dom";
import { Route } from "react-router";
import { BrowserRouter, Switch } from "react-router-dom";
import { lang } from "./il8n/lang";
import { siteMapByLocale } from "./const";

// Analytics
import ReactGA from "react-ga";
import TagManager from 'react-gtm-module'
import { UA } from "./const";

// Redux
import { Provider } from "react-redux";
import configureStore from "./configureStore";
import { PersistGate } from "redux-persist/lib/integration/react";


// Page Wrappers
import App from "./App/App";
import AsyncComponent from "./components/Async/AsyncComponent";

// Global Assets
/*eslint-disable no-unused-vars*/
/*eslint-enable no-unused-vars*/

// Global CSS
import "./index.css";

// Localized Overide CSS
import "./localeOverrides/en_us.css";

// import {initialState} from './Reducers/Main';

// Pages
const Home = AsyncComponent(() => import("./components/Pages/Home/Home"));
const MeetHeros = AsyncComponent(() =>
  import("./components/Pages/MeetHeros/MeetHeros")
);
const Printables = AsyncComponent(() =>
  import("./components/Pages/Printables/Printables")
);


const Toys = AsyncComponent(() => import("./components/Pages/Toys/Toys"));
const Toy = AsyncComponent(() => import("./components/Pages/Toy/Toy"));
const NoMatch = AsyncComponent(() =>
  import("./components/Pages/NoMatch/NoMatch")
);

const Seasonal = AsyncComponent(() => import("./components/Pages/Fall/Seasonal"));




const createBrowserHistory = require("history").createBrowserHistory;

// Create the Store
let { store, persistor } = configureStore();

// GEO IP
const GEOIP = async ()=>{
  let geo_ip_langset
  const access_key = '16109961051f2040a97cc3a320b398dc';

  await fetch('https://api.ipstack.com/check?access_key='+ access_key)
    .then(res => res.json())
    .then(
      (result) => {
        console.log('IP _ CHECK', result)
        geo_ip_langset=`${result.location.languages[0].code}_${result.country_code.toLowerCase()}`
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        console.log('ip check not working', error)
      }
    )

  return geo_ip_langset;
}

// Analytics

const tagManagerArgs = {
  gtmId: 'GTM-PXKTRCX'
}

TagManager.initialize(tagManagerArgs)


ReactGA.initialize(UA);
function logPageView() {
  
  if (store.getState().gaToggle.status) {
    console.log('MissionStationPlayset', window.location.pathname)
    window.scrollTo(0, 0); // scroll page to top

    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  if(window.location.pathname === "/MissionStationPlayset"){
    window.location.href = "https://mightyexpress.s3.amazonaws.com/videos/EN-US_MTE_MainTrailer_1920x1080_H264_2ch_Post_Bug.mp4";
  }
}

// Set Lang on Load (Seems Messy)
const pathLang = window.location.pathname.split('/')[1];
const initialLangSet = async ()=>{
  if(pathLang !== lang.getLanguage() && pathLang){
    if (pathLang in siteMapByLocale){
      console.log('PATH LANG', pathLang)
      lang.setLanguage(pathLang);
    } else {
      lang.setLanguage('en_us');
    }
  } else if(!pathLang){
    let geoIP = await GEOIP();
    if(geoIP !== lang.getLanguage() && geoIP){
      lang.setLanguage(geoIP);
      window.location.replace('/'+geoIP);
    }else{
      window.location.replace('/en_us');
    }

    // window.location.replace('/en_us');
  }

}
initialLangSet().finally(() => {
  const history = createBrowserHistory();

  history.listen(function (location) {
    logPageView();
  });
  
  logPageView();
  
  // Define Routes
  const routes = [
    {
      path: "/",
      exact: true,
      component: Home,
    },
    {
      path: "/:locale",
      exact: true,
      component: Home,
    },
    // {
    //   path: "/MissionStationPlayset",
    //   exact: true,
  
    // }
    {
      path: "/:locale/meettheheroes",
      exact: true,
      component: MeetHeros,
    },
    {
      path: '/:locale/toys/:pid',
      exact: false,
      component: Toy
    },
    {
      path: "/:locale/toys",
      exact: true,
      component: Toys,
    },
    {
      path: "/:locale/printables",
      exact: true,
      component: Printables,
    },
    {
      path: "/:locale/activities",
      exact: true,
      component: Printables,
    },
    {
      path: "/:locale/valentines",
      exact: true,
      component: Seasonal,
    },
    {
      path: "",
      exact: false,
      component: NoMatch,
    },
  ];
  
  ReactDOM.render(
    // let {gaToggle} = this.props;
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter onUpdate={logPageView}>
          <div>
            <App>
              <Switch>
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    component={route.component}
                  />
                ))}
              </Switch>
            </App>
          </div>
        </BrowserRouter>
      </PersistGate>
    </Provider>,
    document.getElementById("root")
  );  
});




// WEBPACK FOOTER //
// ./src/index.js